export default __webpack_public_path__ + "static/media/_dkg_leber_rgb.2bd94074.svg";